import { Container } from '@/components/ui/container';
import { LinkPreview } from '@/components/ui/link-preview';

export default function LandingCta() {
	return (
		<Container className="max-w-3xl relative">
			<div className="text-center max-w-3xl mx-auto">
				<h2 className="text-3xl md:text-4xl font-bold mb-6 font-space-grotesk">
					Every business is different. That&apos;s why we start with a conversation.
				</h2>
				<div className="text-lg text-muted-foreground mb-8">
					Not sure what you need? Let&apos;s explore it together.
				</div>
				<div className="text-lg text-muted-foreground mb-8">
					Choose between a{' '}
					<LinkPreview url="/contact" className="font-bold">
						Discovery Session
					</LinkPreview>{' '}
					or try our{' '}
					<LinkPreview url="/calculator" className="font-bold">
						Project Calculator
					</LinkPreview>{' '}
					to build your own quote.
				</div>
			</div>
		</Container>
	);
}
